import { MessageCircle } from "lucide-react";

const MESSAGE = encodeURIComponent("Olá, quero conhecer a VoxCampaign.");

export function FloatingWhatsApp() {
  return (
    <a
      href={`https://wa.me/5561982415240?text=${MESSAGE}`}
      target="_blank"
      rel="noopener"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    >
      <span className="hidden sm:inline-block px-4 py-2 rounded-full bg-white border border-border shadow-elegant text-sm font-semibold text-foreground opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all">
        Falar com especialista
      </span>
      <span className="relative h-14 w-14 rounded-full bg-success text-white flex items-center justify-center shadow-elegant animate-pulse-glow">
        <MessageCircle className="h-7 w-7" strokeWidth={2.2} />
      </span>
    </a>
  );
}
